import React from "react"

import Layout from "src/components/core/templates/layout"
import Hero from "src/components/core/templates/hero"
import Seo from "src/components/seo"

import * as styles from "./contact-us.module.css"

const AboutUs = () => {
  const pageConfig = {
    title: "Contact us",
    description:
      "Tom & Giles set up TAG in 2019 to meet the needs of production companies and location managers, rather than just being an equipment delivery service for film shoots.",
    variant: "clouds",
  }

  return (
    <Layout>
      <Seo title="Contact Us" />
      <Hero pageConfig={ pageConfig } />
      <div className={ styles.container }>
        <h2>CONTACT US</h2>
        <div>Contact us</div>
      </div>
    </Layout>
  )
}

export default AboutUs
